import type { FC } from 'react'
import { useState } from 'react'

import GuideMeButton from '@/components/GuideMeButton'

import Sidebar from './Sidebar/Index'

export type Step = {
  title: string
  description: string
  supportingDocuments:
    | {
        fileName: string
        thumbnail: string
        specifiedType: string
      }[]
    | null
  callToAction: {
    url: string
    text: string
  } | null
}

interface Props {
  steps: Step[]
}

const GuideMe: FC<Props> = ({ steps }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && <Sidebar steps={steps} onClose={() => setIsSidebarOpen(false)} />}

      <GuideMeButton
        disabled={!steps || steps.length === 0}
        onClick={() => setIsSidebarOpen(true)}
      />
    </>
  )
}

export default GuideMe
